import { Link } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import "../../assets/css/tasklist.scss";
import ImgVector from "../../assets/images/img_vector.svg";
import { AppContext } from "../../context/AppContext";
import {
  multipartPostCallWithErrorResponse,
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Loader from "../Loader";
import { ToastMsg } from "../TostMsg";
import Pagination from "../../sharedComponent/Pagination";
import { Button, Select, Table } from "../../components/ui";
import AnnouncementFormModal from "./components/AnnouncementFormModal";
import ViewsListModal from "./components/ViewsListModal";
import useAnnouncementForm from "./hooks/useAnnouncementForm";

const PRIORITY_CLASS = {
  High: "ann-table__priority ann-table__priority--high",
  Medium: "ann-table__priority ann-table__priority--medium",
  Low: "ann-table__priority ann-table__priority--low",
};

const AllAnnouncement = () => {
  const { sidebar, userData, permissions } = useContext(AppContext);

  const [allannList, setAllannList] = useState([]);
  const [viewCountList, setViewCountList] = useState([]);
  const [announcment, setAnnouncment] = useState([]);
  const [employName, setEmployName] = useState([]);
  const [priority, setPriority] = useState([]);
  const [branchName, setBranchName] = useState([]);
  const [teamName, setTeamName] = useState([]);

  const [loading, setLoading] = useState(false);
  const [mloading, setMLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [showCreate, setShowCreate] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showViewsList, setShowViewsList] = useState(false);

  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUsersPerPage] = useState(25);

  const formState = useAnnouncementForm();
  const { form, validated, setValidated, reset } = formState;

  const startIndex = currentPage * usersPerPage;
  const endIndex = startIndex + parseInt(usersPerPage);

  const pageChangeHandler = ({ selected }) => setCurrentPage(selected);

  const searchedDataPageCounts =
    allannList &&
    allannList.length &&
    allannList.filter((item) =>
      item.ProjectName?.toLowerCase().includes(searchValue)
    );

  useEffect(() => {
    getAnnounctmentApi();
    getBranchApi();
    getTeamApi();
    getEmployeeApi();
    getPriorityApi();
  }, []);

  const getAnnounctmentApi = () => {
    setLoading(true);
    PostCallWithErrorResponse(
      ApiConfig.ALL_ANNOUNCEMENTS_LIST,
      JSON.stringify({
        EmpId: Number(userData.EmpId),
        OrgId: Number(userData.OrgId),
      })
    )
      .then((res) => {
        setLoading(false);
        setAllannList(res.json.Data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getViewCountApi = (id) => {
    setMLoading(true);
    PostCallWithErrorResponse(
      ApiConfig.VIEW_MEMBER_LIST,
      JSON.stringify({
        OrgId: Number(userData.OrgId),
        annoucementid: id,
      })
    )
      .then((res) => {
        setMLoading(false);
        setViewCountList(res.json.Data);
      })
      .catch(() => {
        setMLoading(false);
      });
  };

  const getPreViewCountApi = (id) => {
    setMLoading(true);
    PostCallWithErrorResponse(
      ApiConfig.PREVIEW_ANNOUNCEMENTS,
      JSON.stringify({
        AnnoucementId: id,
        OrgId: Number(userData.OrgId),
      })
    )
      .then((res) => {
        setMLoading(false);
        setAnnouncment(res.json.Data);
      })
      .catch(() => {
        setMLoading(false);
      });
  };

  const getBranchApi = () => {
    PostCallWithErrorResponse(
      ApiConfig.ORGANIZATION_BRANCH,
      JSON.stringify({ OrgId: Number(userData.OrgId) })
    ).then((res) => setBranchName(res.json.Data));
  };

  const getTeamApi = () => {
    PostCallWithErrorResponse(
      ApiConfig.ORGANIZATION_TEAM,
      JSON.stringify({ OrgId: Number(userData.OrgId) })
    ).then((res) => setTeamName(res.json.Data));
  };

  const getEmployeeApi = () => {
    PostCallWithErrorResponse(
      ApiConfig.EMPLOEE_NAME_LIST,
      JSON.stringify({ OrgId: Number(userData.OrgId) })
    ).then((res) => setEmployName(res.json.Data));
  };

  const getPriorityApi = () => {
    simpleGetCallWithErrorResponse(ApiConfig.PRIORITY_MASTER).then((res) =>
      setPriority(res.json.Data)
    );
  };

  const updateViewCoutnapi = (id) => {
    PostCallWithErrorResponse(
      ApiConfig.UPDATE_VIEW_COUNT,
      JSON.stringify({
        EmpId: Number(userData.EmpId),
        OrgId: Number(userData.OrgId),
        AnnoucementId: id,
      })
    );
  };

  const AddorUpdateAnnouncmentApi = async (e) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    if (formEl.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      const fromdata = new FormData();
      fromdata.append("Title", form.Title);
      fromdata.append("AnnouncementDate", form.AnnouncementDate);
      form.AssignToBranchId.forEach((branchId) => {
        fromdata.append("AssignToBranchId", branchId);
      });
      fromdata.append("Message", form.Message);
      fromdata.append("PriorityId", form.PriorityId);
      fromdata.append("AttachmentPreview", form.AttachmentPreview);
      fromdata.append("OrgId", form.OrgId);
      fromdata.append("ViewCount", form.ViewCount);
      fromdata.append("AssignToTeamId", form.AssignToTeamId);
      fromdata.append("AssignToEmployeeId", form.AssignToEmployeeId);
      fromdata.append("CreatedBy", form.CreatedBy);
      fromdata.append("AttachmentPath", form.AttachmentPath);
      setBtnLoading(true);
      multipartPostCallWithErrorResponse(
        ApiConfig.CRATE_ANNOUNCEMENT,
        fromdata
      )
        .then((response) => {
          setBtnLoading(false);
          if (response.json.Success) {
            ToastMsg("success", response.json.Message);
            getAnnounctmentApi();
            setShowCreate(false);
            reset();
          }
        })
        .catch(() => {
          setBtnLoading(false);
        });
    }
    setValidated(true);
  };

  const openCreateModal = () => {
    reset();
    setShowCreate(true);
  };

  const openViewModal = (announcementId) => {
    setShowView(true);
    getPreViewCountApi(announcementId);
  };

  const closeCreateModal = () => setShowCreate(false);
  const closeViewModal = () => setShowView(false);
  const closeViewsListModal = () => setShowViewsList(false);

  const renderEmptyState = () => (
    <div className="ann-empty">
      <div className="ann-empty__icon" aria-hidden="true">
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M11 5.882V19.24a1.76 1.76 0 0 1-3.417.592l-2.147-6.15M18 13a3 3 0 1 0 0-6M5.436 13.683A4.001 4.001 0 0 1 7 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 0 1-1.564-.317z" />
        </svg>
      </div>
      <h3 className="ann-empty__heading">No announcements yet</h3>
      <p className="ann-empty__text">
        When announcements are posted to your organization, they will appear
        here.
      </p>
      {permissions && permissions["Create Announcement"] && (
        <Button variant="primary" onClick={openCreateModal}>
          + Create Announcement
        </Button>
      )}
    </div>
  );

  const hasAnnouncements = allannList && allannList.length > 0;

  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="ann-page">
          <header className="ann-page__header">
            <h1 className="ann-page__title">Announcement</h1>
            {permissions && permissions["Create Announcement"] && (
              <div className="ann-page__create">
                <Button variant="primary" onClick={openCreateModal}>
                  + Create Announcement
                </Button>
              </div>
            )}
          </header>

          <div className="ann-toolbar">
            <div className="ann-toolbar__tabs">
              {permissions && permissions["View All Announcement"] && (
                <Link to="/AllAnnouncement" className="ann-toolbar__tab">
                  <Button variant="primary" size="sm">
                    All Announcement
                  </Button>
                </Link>
              )}
              {permissions && permissions["View My Announcement"] && (
                <Link to="/MyAnnouncement" className="ann-toolbar__tab">
                  <Button variant="ghost" size="sm">
                    My Announcement
                  </Button>
                </Link>
              )}
            </div>

            <div className="ann-toolbar__entries">
              <p className="ann-toolbar__entries-label">Entries per page</p>
              <Select
                aria-label="Entries per page"
                defaultValue="25"
                className="ann-toolbar__entries-select"
                onChange={(e) => {
                  setUsersPerPage(e.target.value);
                  setCurrentPage(0);
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
              </Select>
            </div>
          </div>

          <div className="ann-table-wrapper">
            {loading ? (
              <div className="ann-table__loader">
                <Loader />
              </div>
            ) : hasAnnouncements ? (
              <Table className="ann-table">
                <thead>
                  <tr>
                    <th>Sr.no</th>
                    <th>Branch, Team, Members</th>
                    <th>Title</th>
                    <th>Image</th>
                    <th>Description</th>
                    <th>Created By</th>
                    <th>Date</th>
                    <th>Priority</th>
                  </tr>
                </thead>

                <tbody>
                  {allannList
                    .slice(startIndex, endIndex)
                    .map((announcement, index) => (
                      <tr
                        key={"sdfe3" + index}
                        onClick={() =>
                          updateViewCoutnapi(announcement.AnnouncementId)
                        }
                      >
                        <td>{index + 1}</td>
                        <td>{announcement.AssignedToName}</td>
                        <td>{announcement.Title}</td>
                        <td
                          onClick={() =>
                            openViewModal(announcement.AnnouncementId)
                          }
                          className="ann-table__cell-clickable"
                        >
                          <img
                            className="ann-table__image"
                            src={
                              announcement.ImagePath
                                ? ApiConfig.BASE_URL_FOR_IMAGES +
                                  announcement.ImagePath
                                : ImgVector
                            }
                            alt=""
                          />
                        </td>
                        <td
                          onClick={() =>
                            openViewModal(announcement.AnnouncementId)
                          }
                          className="ann-table__cell-clickable"
                        >
                          <div className="ann-table__description">
                            {announcement.Description}
                          </div>
                        </td>
                        <td>{announcement.CreatedBy}</td>
                        <td>{announcement.Date}</td>
                        <td>
                          {PRIORITY_CLASS[announcement.Priority] ? (
                            <span
                              className={PRIORITY_CLASS[announcement.Priority]}
                            >
                              {announcement.Priority}
                            </span>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            ) : (
              renderEmptyState()
            )}
          </div>

          <div className="ann-pagination">
            <Pagination
              data={allannList}
              pageChangeHandler={pageChangeHandler}
              usersPerPage={usersPerPage}
              currentPage={currentPage}
              searchValue={searchValue}
              searchedDataPageCounts={searchedDataPageCounts}
            />
          </div>
        </div>
      </div>

      <AnnouncementFormModal
        mode="create"
        show={showCreate}
        onHide={closeCreateModal}
        form={form}
        updateField={formState.updateField}
        validated={validated}
        selectedBranches={formState.selectedBranches}
        setSelectedBranches={formState.setSelectedBranches}
        reset={reset}
        branchName={branchName}
        teamName={teamName}
        employName={employName}
        priority={priority}
        onSubmit={AddorUpdateAnnouncmentApi}
        btnLoading={btnLoading}
      />

      <AnnouncementFormModal
        mode="view"
        show={showView}
        onHide={closeViewModal}
        announcements={announcment}
        loading={mloading}
      />

      <ViewsListModal
        show={showViewsList}
        onHide={closeViewsListModal}
        viewCountList={viewCountList}
        loading={mloading}
      />
    </>
  );
};

export default AllAnnouncement;
